import bankCardSvg from '@raison/static/icons/bank-card-line.svg';
import React from 'react';
import {AlertHandler, AlertPane} from '~/entities/alerts';
import {Wish} from '~/library/prelude';

const CardAlertHandler: AlertHandler<{
    cardId: string | number;
    cardNumber: string;
}> = {
    subject: 'card-operation-awaits-card-verification',
    Manager({content, children}) {
        return children(Wish.assert(validate, content));
    },
    Display({content}) {
        const {cardId, cardNumber} = content;
        return (
            <AlertPane linkTo={`/cards/${cardId}/verify`} messageSummary={'Top up on hold'} icon={bankCardSvg}>
                {`Verify card ${cardNumber}`}
            </AlertPane>
        );
    },
};

const validate = Wish.struct({
    cardId: Wish.choice(Wish.string, Wish.number),
    cardNumber: Wish.string,
});

export const CardAlertHandlersBatch = {
    [CardAlertHandler.subject]: CardAlertHandler,
};
